// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__+C4lH","slider":"styles_slider__LNMCS","disabled":"styles_disabled__ejB-C","round":"styles_round__RDGZk"};